module.exports = __webpack_public_path__ + "media/flags/bw-3e6fc9f4.svg";